import apiService from '@/state/services/Api';
import _cloneDeep from 'lodash-es/cloneDeep.js';

const URL = 'device-profiles'

const state = {
  deviceProfiles: [],
  paginationData: { count: 0, previous: null, next: null },
};

const getters = {

  getDeviceProfiles(state) { return _cloneDeep(state.deviceProfiles) },

  getDeviceProfileByUuid: (state) => (uuid) => {
    return _cloneDeep(state.deviceProfiles.find(e => e.uuid === uuid));
  },

  getPaginationData(state) { return state.paginationData },

};

const mutations = {

  SET_PAGINATION_DATA(state, data) { state.paginationData = data; },

  SET_DEVICE_PROFILES(state, profiles) { state.deviceProfiles = profiles; },

  ADD_DEVICE_PROFILE(state, profile) { state.deviceProfiles.push({...profile}); },

};

const actions = {

  async getDeviceProfiles({ commit, state }, refresh = true) {
    try {
      commit('SET_DEVICE_PROFILES', []);
      const url = !refresh && state.paginationData.next ? state.paginationData.next : URL;
      const response = await apiService.query(url);
      commit(refresh ? 'SET_DEVICE_PROFILES' : 'ADD_DEVICE_PROFILE', response.results);
      commit('SET_PAGINATION_DATA', { count: response.count, previous: response.previous, next: response.next });
    } catch (e) {
      return Promise.reject(e);
    }
  }

};

export default { namespaced: true, state, getters, mutations, actions };
